module.exports = __webpack_public_path__ + "img/hand-love.ae042f00.svg";